import { type DashboardTranslations } from './dashboard.translations.pl.ts';

export const dashboardTranslations: DashboardTranslations = {
  areas: {
    firstChoice: 'premier choix',
    otherChoice: 'deuxième ou troisième choix',
    subtitle: 'Candidats ayant choisi le domaine',
    title: "Domaines d'intérêt",
  },
  close: 'Fermer',
  dataView: 'Données sous forme de tableau',
  error: 'Impossible de charger les statistiques. Réessayez dans un instant.',
  feed: {
    empty: "Rien ne s'est encore passé sur cette période",
    events: {
      QUIZ_FINISHED: 'Quiz terminé',
      QUIZ_STARTED: 'Quiz commencé',
      REGISTERED: 'Nouveau candidat',
    },
    subtitle: 'Derniers événements, sans données personnelles',
    title: 'En direct',
  },
  filter: {
    clear: 'Effacer le filtre',
    region: '{{region}} · {{type}}',
    types: {
      INTERNSHIP: 'lieu de stage',
      STUDY: 'université',
    },
  },
  funnel: {
    ofRegistered: '{{value}} des inscrits',
    stages: {
      EMAIL_VERIFIED: 'E-mail confirmé',
      PERSONAL_DATA: 'Données personnelles',
      QUIZ_FINISHED: 'Quiz terminé',
      QUIZ_STARTED: 'Quiz commencé',
      RECOMMENDED: 'Recommandation',
      REGISTERED: 'Inscription',
    },
    stepConversion: "{{value}} de l'étape précédente",
    subtitle: 'Combien de candidats atteignent chaque étape',
    title: 'Entonnoir de recrutement',
  },
  heatmap: {
    sessions: 'sessions de quiz',
    subtitle: 'Quand les candidats passent le quiz (heure polonaise)',
    title: 'Activité dans la semaine',
  },
  kpis: {
    averageQuizMinutes: 'Durée moyenne du quiz',
    averageQuizPoints: 'Score moyen au quiz',
    candidates: 'Candidats',
    conversion: 'Taux de réussite',
    conversionHint: 'recommandés parmi les inscrits',
    fairCandidates: 'Issus des salons',
    minutes: '{{value}} min',
    noPrevious: 'depuis le début du recrutement',
    quizzesFinished: 'Quiz terminés',
    recommended: 'Recommandés',
    vsPrevious: 'vs les {{days}} jours précédents',
  },
  live: 'En direct',
  map: {
    candidates: 'candidats',
    clickHint: 'Cliquez sur une voïvodie pour filtrer tout le tableau de bord',
    layers: {
      INTERNSHIP: 'Lieu de stage',
      STUDY: 'Université',
    },
    outside: {
      INTERNSHIP: "{{count}} feraient leur stage n'importe où en Pologne",
      STUDY: "{{count}} étudient dans une université hors liste",
    },
    ranking: 'Le plus de candidats',
    share: 'part',
    subtitle: {
      INTERNSHIP: 'Voïvodies et villes où les candidats souhaitent faire leur stage',
      STUDY: 'Voïvodies où étudient les candidats',
    },
    title: "D'où viennent les candidats",
  },
  periods: {
    all: 'Tout le recrutement',
    days30: '30 jours',
    days7: '7 jours',
    days90: '90 jours',
    label: 'Période',
  },
  presentation: {
    start: 'Mode présentation',
    stop: 'Quitter la présentation',
  },
  profile: {
    gender: 'Genre',
    genders: {
      FEMALE: 'femmes',
      MALE: 'hommes',
      UNKNOWN: 'non précisé',
    },
    languages: "Langue de l'application",
    studentStatus: 'Statut',
    subtitle: 'Qui sont les candidats ayant donné leurs données',
    title: 'Profil des candidats',
    typeOfStudy: "Type d'études",
    universities: 'Universités les plus choisies',
    yearOfStudy: "Année d'études",
  },
  quiz: {
    candidates: 'candidats',
    notRecommended: 'sans recommandation',
    points: 'pts',
    recommended: 'avec recommandation',
    scores: {
      AVERAGE: 'Moyen',
      GOOD: 'Bon',
      LOW: 'Faible',
      OUTSTANDING: 'Exceptionnel',
      VERY_GOOD: 'Très bon',
    },
    subtitle: 'Points des quiz terminés et seuils des appréciations',
    title: 'Résultats du quiz',
  },
  regions: {
    'PL-02': 'Basse-Silésie',
    'PL-04': 'Couïavie-Poméranie',
    'PL-06': 'Lublin',
    'PL-08': 'Lubusz',
    'PL-10': 'Lodz',
    'PL-12': 'Petite-Pologne',
    'PL-14': 'Mazovie',
    'PL-16': 'Opole',
    'PL-18': 'Basses-Carpates',
    'PL-20': 'Podlachie',
    'PL-22': 'Poméranie',
    'PL-24': 'Silésie',
    'PL-26': 'Sainte-Croix',
    'PL-28': 'Varmie-Mazurie',
    'PL-30': 'Grande-Pologne',
    'PL-32': 'Poméranie occidentale',
  },
  saveImage: "Enregistrer l'image",
  skills: {
    assessments: 'évaluations',
    languages: 'Langues : niveau bon ou avancé',
    strongShare: "s'évaluent à un niveau bon ou avancé",
    subtitle: "Part des candidats qui s'évaluent à un niveau bon ou avancé",
    title: 'Compétences les plus fortes',
  },
  subtitle: '{{from}} – {{to}}',
  timeline: {
    fairRegistrations: 'inscriptions sur les salons',
    quizzesFinished: 'quiz terminés',
    registrations: 'inscriptions',
    subtitle: 'Les candidats jour après jour',
    title: 'Afflux de candidats',
  },
  title: 'Le recrutement en chiffres',
  updatedAt: 'Mise à jour {{time}}',
};
